import React from 'react';

function OptionLabel({ label, value }) {
  return <div data-testid={`option-${value}`}>{label}</div>;
}

export default OptionLabel;
